import React from 'react';
import loadingImage from '../../assets/images/loading/levAR_logo.svg';

const AssetBlocked = () => {
  return (
    <div className='AssetBlocked'>
      <div className="AssetBlocked-Section">
        <img src={loadingImage} className='AssetBlocked-logo' alt="levAR"/>
        <h2>Asset is not available</h2>
      </div>
    </div>
  )
}

export default AssetBlocked;
